import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import { GET_PRODUCT_DETAILS, GET_OPEN_PAYMENTS } from '@/utils/store/actionTypes'
import { IS_AUTHENTICATED, OPEN_PAYMENTS, NEEDS_TO_UPDATE_PAYMENT_METHOD, AUTH_ID } from '@/utils/store/getterTypes'
import { SET_REDIRECT_URL } from '@/utils/store/mutationTypes'
import { stripLanguageRegex, capitalize } from '@/utils/general'
import webshopMixin from '@/mixins/webshop'

export default {
  async fetch () {
    await Promise.all([
      this.userId ? this.getOpenPayments() : null,
      this.getAndSetProductDetails()
    ])
  },
  mixins: [webshopMixin],
  data () {
    return {
      isProductLoading: false,
      product: {}
    }
  },
  computed: {
    productDetailPageComponentProps () {
      return {
        breadcrumbs: [
          {
            title: this.$t('Loyalty.Breadcrumbs.Webshop'),
            link: '/webshop'
          },
          {
            title: capitalize(this.$route.params.category)
          },
          {
            title: this.product?.name
          }
        ],
        category: this.$route.params.category || '',
        country: this.country,
        productSlug: this.$route.params.slug || '',
        product: this.product,
        locale: this.locale,
        isProductLoading: this.isProductLoading,
        spaazaUser: this.spaazaUser,
        isAuthenticated: this.isAuthenticated,
        cart: this.cart,
        cartTotal: this.cartTotal,
        isWalletFrozen: this.isWalletFrozen,
        openPayments: this.openPayments,
        needsToUpdatePaymentMethod: this.needsToUpdatePaymentMethod,
        userId: this.userId
      }
    },
    ...mapState('app', {
      country: state => state.country,
      locale: state => state.locale
    }),
    ...mapState('spaaza', {
      spaazaUser: state => state
    }),
    ...mapState('webshop', {
      isWalletFrozen: state => state.isWalletFrozen
    }),
    ...mapGetters('auth', {
      isAuthenticated: IS_AUTHENTICATED,
      needsToUpdatePaymentMethod: NEEDS_TO_UPDATE_PAYMENT_METHOD,
      userId: AUTH_ID
    }),
    ...mapGetters('payment', {
      openPayments: OPEN_PAYMENTS
    })
  },
  methods: {
    async getAndSetProductDetails () {
      try {
        this.isProductLoading = true

        const product = await this.getProductDetails({ slug: this.$route.params.slug })
        this.product = product
      } catch (error) {
        this.$ota.general.logError(error)
      } finally {
        this.isProductLoading = false
      }
    },
    unauthenticatedProductClick () {
      this.setRedirectUrl({ url: this.$route.fullPath.replace(stripLanguageRegex, '') })
      this.$router.push(this.$i18n.localePath({ name: 'login' }))
    },
    ...mapActions('webshop', {
      getProductDetails: GET_PRODUCT_DETAILS
    }),
    ...mapMutations('auth', {
      setRedirectUrl: SET_REDIRECT_URL
    }),
    ...mapActions('payment', {
      getOpenPayments: GET_OPEN_PAYMENTS
    })
  },
  head () {
    return {
      title: `ON THAT ASS | ${this.product.name}`
    }
  }
}
